// CommitChart.js


import {Bar} from 'vue-chartjs/dist/vue-chartjs'

export default {
  extends: Bar,
  name: 'food-diary-stacked-history',
  props: ['data'],
  mounted() {
    let self = this;
    self.render();
  },
  methods: {
    render() {
      let self = this;
      self.renderChart(self.data, {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex];
              let percentage = parseInt(data.datasets[tooltipItem.datasetIndex].percentages[tooltipItem.index]);
              return tooltipItem.yLabel.toFixed(1) + 'kcal ' + '(' + percentage + '% ' + data.datasets[tooltipItem.datasetIndex].label + ')';
            }
          },
          displayColors: false,
          xPadding: 16,
          yPadding: 16,
          titleFontFamily: "Poppins",
          titleFontStyle: "200",
          bodyFontFamily: "Poppins",
          backgroundColor: "#0179d5",
          titleFontSize: 16,
          titleFontColor: "white",
          bodyFontColor: "white",
          bodyFontSize: 14,
          intersect: false
        },
        title: {
          display: true,
          position: 'left',
          text: "CALORIES (kcal)"
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/FoodDiary/Graphs/StackedHistory/stackedBar.js